export const HEADER_TITLE = 'KG Auction Hub';
